import { JSX, useCallback } from 'react'

import { RichTextEditor, transformTextToNewEditor } from 'core-components/library/richTextEditor'

import { IFrame } from '../content/iframe/IFrame'
import { LibraryContent } from '../content/libraryContent/LibraryContent'
import { IRenderCustomContentParams } from '../flexItem/models/IRenderCustomContent'

export type TRenderWidgetByType = (params: IRenderCustomContentParams) => JSX.Element | null

export const useRenderCustomWidget = (renderWidgetByType?: TRenderWidgetByType) => {
  const renderCustomWidget = useCallback(
    (params: IRenderCustomContentParams) => {
      const { widget } = params
      const renderWidget = (defaultValue: JSX.Element | null) => {
        return (renderWidgetByType && renderWidgetByType(params)) || defaultValue
      }
      if (widget.type === 'Static') {
        const preparedContent = transformTextToNewEditor(widget.content)

        return renderWidget(
          <RichTextEditor value={preparedContent} toolbarVisible={false} disabled />
        )
      }

      if (widget.type === 'Iframe') {
        return renderWidget(<IFrame widget={widget} />)
      }

      if (widget.type === 'FromLibrary') {
        return renderWidget(<LibraryContent widget={widget} />)
      }

      return renderWidget(null)
    },
    [renderWidgetByType]
  )

  return { renderCustomWidget }
}
